
import { Button, Container, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { memo } from 'react';
import CheckboxListFiltr from './FiltrCompanent/CheckboxListFiltr';
import SkeletonFilter from './Skeleton/SceletonFilter';



const Filter =  memo( (props) => {

  let submitForm = () => {
    props.setCurrentPage(1);
    let currentPage = 1;
    let filter = "";
    let valueSelected = props.valueSelected;
    props.paramsQuerry.paramsQuerry.map((getpar, ii) => {
      let filtr = getpar[0].split(/^(.+)+\[(.+)+\](.+)+/gm)[1];
      let filtrSort = getpar[0];
      let filtrSortValue = getpar[1];
      let filtrGetParamsKey = getpar[0].split(/^(.+)+\[(.+)+\](.+)+/gm)[2];
      let filtrGetParamsValue = Number(getpar[1]);

      if (filtrSort == "tag") {

        filter += `${filtrSort}=${filtrSortValue}&`;
      }
    });
    for (var key in props.checked) {
      props.checked[key].map(u => {
        filter += `filter[${key}][]=${u}&`;
      })
    }
    //?filter[style][]=356

    filter = filter.trim().slice(0, -1);

    props.getCatalogItems(props.pageSize, currentPage, "&" + filter + "&" + valueSelected);
    props.setFiltr("?" + filter);


    props.getFiltersUrl(filter);
    window.location.href = `/${props.catalogUrl}/?${filter}&${valueSelected}&page=${currentPage}&countItems=${props.pageSize}`;

  }

  let resetForm = () => {
    props.setCurrentPage(1);
    let valueSelected = props.valueSelected;
    let currentPage = 1;
    let checkedNull = [];
    props.setCheckenFiltr(checkedNull);
    let filter = "";

    filter = filter.trim().slice(0, -1);

    props.getCatalogItems(props.pageSize, currentPage, filter);
    props.setFiltr("?" + filter);

    props.params.navigate(`/${props.catalogUrl}/?${valueSelected}`);
  }
  const checkedConst = () => {
    let cCh = 0
    for (var key in props.checked) {
      props.checked[key].map(u => {
        if (u !== "") {
          cCh = cCh + 1;
        }
      })
    }
    return cCh;

  }
  
  return (

    <Container maxWidth="sm" sx={{ backgroundColor: "#f5f5f5", borderRadius: "14px", mb: 2, position: "relative" }} >
      {checkedConst() > 0 &&
        <div style={{ mt: 1, mb: 1, fontWeight: 600, display: "flex", justifyContent: "flex-end", position: "absolute", top: "-33px", right: "0" }}>
          <Button variant="text" color="success" size="small" onClick={resetForm}>Сбросить все</Button>
        </div>
      }
      <Box
        component="form"
        sx={
          { m: 1, width: '32ch', textAlign: "left", maxWidth: { xs: 290, md: 250 } }
        }
        noValidate
        autoComplete="off"
      >
        <>

          {props.isFetchingFilter ? <SkeletonFilter />
            : props.filterItems
              .map((p, i) => {
                const itemsToDisplayCheked = () => {
                  return p.PROPERTY_VALUE.map((x) => {
                    x["checked"] = props.checked[p.CODE] ? props.checked[p.CODE]?.indexOf(String(x.ID)) !== -1 : false;
                  });
                }
                return (
                  <div key={i}>
                    <CheckboxListFiltr itemsToDisplayCheked={itemsToDisplayCheked} resetForm={resetForm} submitForm={submitForm} id={p.ID} setCheckenFiltr={props.setCheckenFiltr} name={p.NAME} propertyValue={p.PROPERTY_VALUE} propertyValueColor={p.PROPERTY_VALUE.HighloadBlockValue} code={p.CODE} typeDisplay={p.DISPLAY_TYPE} checked={props.checked} getPriceSlide={props.getPriceSlide} getPriceSlideMaxMin={props.getPriceSlideMaxMin} />
                  </div>


                )
              })

          }
        </>
      </Box>

    </Container>





  );
});

export default Filter;